import React, { useState, useEffect, useContext, useRef } from 'react'
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import InputRange from "react-input-range";
import AuthContext from "../../../../context/userAuth.context";
import Lottie from "react-lottie";
import loader from "../../../../assets/Loader/AssetLoader.json";
import Chrome from "react-color";
import swal from "sweetalert";
// import useEyeDropper from 'use-eye-dropper'
// import { ColorPickerModule } from 'ngx-color-picker';
// import EyeDropper from 'react-eyedrop'
// import { Palette } from '@untemps/svelte-palette'    
// import EyeDropper from 'react-eyedropper'



function GreenScreenModel(props) {
    const { authenticationData } = useContext(AuthContext);
    const [imgLoaded, setImgLoaded] = useState(false)
    const [similarity, setSimilarity] = useState(0 * 100)
    const [filename, setFilename] = useState(null)
    const [blend, setBlend] = useState(0 * 100)
    let imgRef = useRef(null)
    const [shapeColor, setShapeColor] = useState(null);
    const [showChrome, setShowChrome] = useState(false)
    const [color, setColor] = useState("hex", "#121212")


    useEffect(() => {
        if (props.show) {

            const style = document.createElement('style');

            style.textContent = `
                .container {
                    position: relative;
                    width: 100%;
                    max-width: 100%;
                    cursor: pointer;
                  }
                  
                  .image {
                    display: block;
                    width: 100%;
                    height: auto;
                  }
                  
                  .overlay {
                    position: absolute;
                    top: 2%;
                    bottom: 0;
                    left: 2%;
                    right: 0;
                    height: 100%;
                    width: 100%;
                    opacity: 1;
                    transition: .3s ease;
                  }
                  .icon {
                    color: white;
                    font-size: 100px;
                    position: absolute;
                    top: 2%;
                    left: 80%;
                    transform: translate(-50%, -50%);
                    -ms-transform: translate(-50%, -50%);
                    text-align: center;
                  }

                  .input-icons i {
                    position: absolute;
                }
                  
                .input-icons {
                    width: 100%;
                }
                  
                
                  
                .input-field {
                    width: 100%;
                    padding: 10px;
                }

                input[type="color"] {
                    -webkit-appearance: none;
                    border: none;
                    width: 32px;
                    height: 32px;
                }
                input[type="color"]::-webkit-color-swatch-wrapper {
                    padding: 0;
                }
                input[type="color"]::-webkit-color-swatch {
                    border: none;
                }
                  
                `;

            document.head.appendChild(style);


            if (props.filename)
                preview_Image()
        }
    }, [props.show, props.filename])

   

    const preview_Image = () => {

        let _similarity = similarity / 100,
            _blend = blend / 100

        if (imgLoaded) {
            setImgLoaded(false)
        }
        let color;

        if(shapeColor){
            color = shapeColor.split('#')[1];
        }
        else{
            color = 'null'
        }


        fetch(`${authenticationData.ApiBaseURL}/api/Export/GetGSPreviewImage?fileName=${props.filename}&similarity=${_similarity}&blend=${_blend}&color=${color}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                // The API now requires a signed-in user for the green-screen service.
                Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('animation_studio_2.0_access_token')).access_token
            }
        }).then(function (res) {
            return res.json();
        }).then(function (res) {

            let response = JSON.parse(res.response)

            if (response.result) {
                if (imgRef.current) {
                    setFilename(response.result)
                    imgRef.current.src = 'https://videobiz.io/bgremove_app/static/output/' + response.result;
                }
                setImgLoaded(true)

            }            


        }).catch(function (reason) {
            // Before: a browser alert('ERROR: ...').
            console.log('Green screen preview failed.', reason);
            setImgLoaded(true);
        });
    }

    const close_model = () => {
        props.onHide(false)
        imgRef.current.src = '';
        props.setfilename('')
        setImgLoaded(false)
        setShapeColor(null)
        setShowChrome(false)
        setSimilarity(0)
        setBlend(0)
        setColor('')
    }

    const addColor = async () => {

        if ("EyeDropper" in window) {
            const eyeDropper = new window.EyeDropper();
            const abortController = new AbortController();
          
            eyeDropper.open({ signal: abortController.signal }).then((result) => {
                setColor(result.sRGBHex)
                setShapeColor(result.sRGBHex)
            }).catch((e) => {
              console.log(e)
            });
          
            setTimeout(() => {
              abortController.abort();
            }, 2000);
        }
        else {
            alert('Eye Dropper is not supported')
        }

            
        
      }

      function onChange({ rgb, hex }) {
        setColor(rgb)
        setShapeColor(rgb)
    }


   

    const save = () => {

        if (shapeColor) {
            let _similarity = similarity / 100,
            _blend = blend / 100
            props.ProcessVideo(props.filename, _similarity, _blend, shapeColor)
            close_model();
        }
        else {
            swal("", "Please Select Color", "info");
        }

    }

    const setColors = ({ r, g, b }) => {
        setColor()
      }


  

    return (
        <Dialog
            fullWidth={true}
            maxWidth={"md"}
            open={props.show}
            onClose={() => close_model()}
            style={{ zIndex: 9999 }}
        >
            <DialogTitle> Green Screen Settings </DialogTitle>
            <DialogContent>

                <div className='parent' >
                    <div className="child" style={{ width: '100%', height: '100%' }}>
                        {imgLoaded == false ? (
                            <Lottie
                                options={{ loop: true, autoplay: true, animationData: loader }}
                                isStopped={false}
                                isPaused={false}
                                style={{ width: '200px', height: '200px', zIndex: '9999999' }}
                            />
                        ) :
                            <div style={{ zIndex: 9999, marginTop: '50px' }} >

                            </div>
                        }
                        <div className="container">
                            <img ref={imgRef} height={'100%'} style={{ display: imgLoaded == false ? 'none' : 'block' }} width={'100%'} />
                            
                        </div>

                    </div>
                </div>  

                <div className='parent' >
                
                    <div className="LabelWithSlider Transparency child" style={{ width: '30%', marginTop: '3%' }} >
                        <div className="settingsTitle">Select Color</div>
                        <div className="opacitySlider">
                            <div className="rangeSlider">
                            <input 
                                type = 'color'
                                id='color'
                                value={color}
                                style={{background: color, aspectRatio: '1/1', borderRadius: '50%'}}
                                onChange={color =>{
                                    setColor(color.target.value)
                                    setShapeColor(color.target.value)
                                }}
                            />
                            </div>
                        </div>
                    </div>
                    <div className="LabelWithSlider Transparency child" style={{ width: '30%' }} >
                        <div className="settingsTitle">Similarity</div>
                        <div className="opacitySlider">
                            <div className="rangeSlider">
                                <InputRange
                                    maxValue={100}
                                    minValue={0}
                                    value={similarity}
                                    onChange={(value) => setSimilarity(value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="LabelWithSlider Transparency child" style={{ width: '30%' }} >
                        <div className="settingsTitle">Blend</div>
                        <div className="opacitySlider">
                            <div className="rangeSlider">
                                <InputRange
                                    maxValue={100}
                                    minValue={0}
                                    value={blend}
                                    onChange={(value) => setBlend(value)}
                                />
                            </div>
                        </div>
                    </div>
                </div>

            </DialogContent>

            <DialogActions>
                <button
                    type="button"
                    class="btn btn-primary"
                    onClick={preview_Image}
                >
                    Load Changes
                </button>
                <button
                    onClick={save}
                    type="button"
                    class="btn btn-primary"
                >
                    Save
                </button>

                <button
                    onClick={close_model}
                    type="button"
                    class="btn btn-primary"
                >
                    Close
                </button>
            </DialogActions>
        </Dialog>
    )
}

export default GreenScreenModel